import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'
import Button from 'components/shared/Button'

const UseExistingEstateDialog = ({estate, onNewOrderOnExistingEstate, onNewEstate}) => {
  const useExisting = () => {
    onNewOrderOnExistingEstate(estate)
  }

  return (
    <Modal
      visible={true}
      closable={false}
      maskClosable={false}
      title="Det finnes allerede et oppdrag på denne adressen"
      footer={[
        <Button key="existing" type="primary" onClick={useExisting}>
          Ekstrabestilling på oppdraget
        </Button>,
        <Button key="new" type="primary" onClick={onNewEstate}>
          Nytt oppdrag
        </Button>,
      ]}
    >
      <p>Følgende oppdrag finnes allerede på adressen:</p>

      {!!estate.customerRef && (
        <p>Kundens referansenummer: #{estate.customerRef}</p>
      )}
      <p>EFKT ref.: #{estate.invisoRef}</p>
    </Modal>
  )
}

UseExistingEstateDialog.propTypes = {
  estate: PropTypes.object,
  onNewOrderOnExistingEstate: PropTypes.func,
  onNewEstate: PropTypes.func,
}

export default memo(UseExistingEstateDialog)
